import React, { memo, forwardRef } from 'react';
import moment from 'moment';
import classNames from 'classnames';

const Input = forwardRef(({ onClick, value, className }, ref) => (
	<div
		aria-hidden
		ref={ref}
		onClick={onClick}
		suppressContentEditableWarning
		className={classNames('date-input-container', className)}
	>
		<span className="day-string-date-picker">{moment(value, 'MM/DD/YYYY').format('dddd').substr(0, 3)}</span>
		<input className="input-shift-date-picker" readOnly value={value} />
		<p className="arrow-wrapper">
			<i className="arrow-down" />
		</p>
	</div>
));

export default memo(Input);
